import { Socket } from "socket.io-client";
import type { DefaultEventsMap } from "@socket.io/component-emitter";
import { socket as mainSocket } from "./socketService";

let socket: Socket<DefaultEventsMap, DefaultEventsMap>;

const connect = (handleConnection: (arg0: boolean) => void) => {
  socket = mainSocket;
  if (socket) handleConnection(true);
  // console.log({API_URL})
  // console.log(authHeader())
  // socket = io(`${API_URL}/v1/user`, {
  //     forceNew: true,
  //     withCredentials: true,
  //     extraHeaders: {
  //         Authorization: authHeader() || '',
  //     }
  // })

  // socket.io.on("open", () => {
  //     socket.io.engine.transport.on("pollComplete", () => {
  //         // const request = SOCKET_LINK.transport.pollXhr.xhr;
  //         // const request = socket.io.engine.transport.pollXhr.xhr;
  //         const cookieHeader = request?.getResponseHeader("set-cookie");
  //         if (!cookieHeader) {
  //             return;
  //         }
  //         cookieHeader.forEach((cookieString: string | string[]) => {
  //             if (cookieString.includes(`${COOKIE_NAME}=`)) {
  //                 const cookie = Array.isArray(cookieString) ? parse(cookieString[0]) : parse(cookieString);
  //                 socket.io.opts.extraHeaders = {
  //                     cookie: `${COOKIE_NAME}=${cookie[COOKIE_NAME]}`
  //                 }
  //             }
  //         });
  //     });
  // });

  // return new Promise((res, _rej) => {
  //     socket.on('connect', () => {
  //         console.log("user connected");
  //         handleConnection(true)
  //         // setTimeout(()=>{
  //         //     joinUser();
  //         // },500)
  //         res(socket);
  //     });
  //     socket.on('disconnect', function () {
  //         handleConnection(false)
  //     });
  //     socket.once('connect_error', function () {
  //         console.log("error")
  //     });
  //     socket.once('connect_timeout', function () {
  //     });
  // })
};

const joinUser = () => {
  // setTimeout(() => {
  socket?.emit("join-admin-room", "");
  // }, 500)
};

const offEvent = (event: string) => {
  socket?.off(event);
};

const adminJoined = (callBack: (data: any) => void) => {
  socket?.on("admin-joined", (data) => {
    // console.log(data, "user-balance");
    callBack(data);
  });
};

const getBalanceData = (setBalance: (arg0: any) => void) => {
  socket?.on("get-user-balance", (data) => {
    // console.log(data, "user-balance");
    if (data && data.data) {
      setBalance(data.data);
    }
  });
};

const getExposureAndOpenBets = (handleChange: () => void) => {
  socket?.on("refresh-match-list", () => {
    handleChange();
  });
};

const refreshBetList = (getCallBack: (data: any) => void) => {
  socket?.on("refresh-bet-list", (data: any) => {
    getCallBack(data);
  });
};

const refreshUserMessage = (getCallBack: (data: any) => void) => {
  console.log("🚀 ~ SUB: refresh-user-message");
  socket?.on("refresh-user-message", (data: any) => {
    getCallBack(data);
  });
};

const refreshCasinoList = (getCallBack: (data: any) => void) => {
  socket?.on("refresh-casino-list", (data: any) => {
    getCallBack(data);
  });
};

const logoutUser = (handleLogout: () => void) => {
  socket?.off("admin-log-out");
  socket?.on("admin-log-out", (data) => {
    console.log(data, "admin-log-out");
    if (data && data.data && data.data.log_out) {
      handleLogout();
    }
  });
};

const userError = (handleLogout: () => void) => {
  socket?.off("admin-error");
  socket?.on("admin-error", (data) => {
    console.log(data, "admin-error");
    if (data && data.status_code === 401) {
      handleLogout();
    }
  });
};

const disconnect = () => {
  socket?.emit("admin-leave", "");
  socket?.disconnect();
};

const chekUserConnected = (connectToRooms = () => {}) => {
  socket?.on("token-verified", (data) => {
    // console.log("IN users-connected - SPORT", data)
    if (data.data.isVerified) {
      connectToRooms();
    } else {
      // console.log('Its me')

      sessionStorage.clear();

      window.location.replace("/");
    }
  });
};

const userSocket = {
  connect,
  offEvent,
  getBalanceData,
  getExposureAndOpenBets,
  refreshCasinoList,
  refreshBetList,
  refreshUserMessage,
  joinUser,
  adminJoined,
  disconnect,
  logoutUser,
  userError,
  chekUserConnected,
};

export default userSocket;
